<template>
  <ipo3-page>
    <template slot="title">{{$t("btns.edit")}}</template>
    <template slot="tools">
      <el-button type="primary" @click="goBack" icon="el-icon-back">{{$t('btns.back')}}</el-button>
    </template>
    <template slot="page">
      <div id="home-edit">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="語言" prop="type">
            <el-select v-model="ruleForm.language" style="margin-right: 14px;">
              <el-option v-for="item in languages" :key="item.name" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="標籤" prop="tag_id">
            <el-button v-if="!tag" @click="onSelectTag">選擇標籤</el-button>
            <el-card class="box-card" v-else>
              <div slot="header" class="clearfix">
                <span>{{tag.name}}</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="onSelectTag">重新選擇</el-button>
              </div>
            </el-card>
          </el-form-item>

          <el-form-item label="新聞" prop="news_id">
            <el-button v-if="!news" @click="onSelectNews">選擇新聞</el-button>
            <el-card class="box-card" v-else>
              <div slot="header" class="clearfix">
                <span>{{news.title}}</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="onSelectNews">重新選擇</el-button>
              </div>
            </el-card>
          </el-form-item>

          <el-form-item label="縮略圖" prop="thumb">
            <ipo3-upload @success="onSuccess" ref="upload"></ipo3-upload>
          </el-form-item>


          <el-form-item label="標題" prop="title">
            <el-input v-model="ruleForm.title" autocomplete="off" maxlength="80">
            </el-input>
          </el-form-item>

          <el-form-item label="簡介" prop="description">
            <el-input v-model="ruleForm.description" type="textarea" :rows="6" maxlength="1000">
            </el-input>
          </el-form-item>

          <el-form-item label="是否顯示" prop="status">
            <el-switch v-model="ruleForm.status"></el-switch>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <el-drawer
        title="標籤綁定"
        :visible.sync="tagDrawer"
        :direction="direction"
        :with-header="true"
        :before-close="handleClose"
      >
        <template slot="title">
            <el-input v-model="tagTitle" placeholder="查找"></el-input>
        </template>
        <div class="page_view">
          <el-table
            ref="tableArr"
            v-loading="isLoading"
            :data="tagTableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleTagSelectionChange"
            :header-cell-style="getRowClass"
          >
            <template v-for="item in tagItems">
              <el-table-column
                :key="item.name"
                header-align="center"
                align="center"
                :label="item.name"
                :prop="item.id"
              ></el-table-column>
            </template>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              class="operate"
              width="160"
            >
              <template scope="scope">
                <div>
                  <el-button @click="onHandleTag(scope.row)" size="mini" type="success">選擇</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleTagSizeChange"
            @current-change="handleTagCurrentChange"
            :current-page="currentTagPage"
            :page-sizes="[10,20,30,40,100]"
            :page-size="tagPaginate"
            layout="total, sizes, prev, pager, next, jumper"
            :total="TagPageCount"
          ></el-pagination>
        </div>
      </el-drawer>

      <el-drawer
        title="新聞綁定"
        :visible.sync="newsDrawer"
        :direction="direction"
        :with-header="true"
        :before-close="handleClose"
      >
        <template slot="title">
            <el-input v-model="newsTitle" placeholder="查找"></el-input>
        </template>
        <div class="page_view">
          <el-table
            ref="tableArr"
            v-loading="isLoading"
            :data="newsTableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleNewsSelectionChange"
            :header-cell-style="getRowClass"
          >
            <template v-for="item in newsItems">
              <el-table-column
                :key="item.name"
                header-align="center"
                align="center"
                :label="item.name"
                :prop="item.id"
              ></el-table-column>
            </template>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              class="operate"
              width="160"
            >
              <template scope="scope">
                <div>
                  <el-button @click="onHandleNews(scope.row)" size="mini" type="success">選擇</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleNewsSizeChange"
            @current-change="handleNewsCurrentChange"
            :current-page="currentNewsPage"
            :page-sizes="[10,20,30,40,100]"
            :page-size="newsPaginate"
            layout="total, sizes, prev, pager, next, jumper"
            :total="newsPageCount"
          ></el-pagination>
        </div>
      </el-drawer>
    </template>
  </ipo3-page>
</template>
<script>
export default {
  name: "home-secondary-edit",
  data() {
    return {
      languages: [{id: 'tw', name: '中文繁體'}, {id: 'cn', name: '中文简体'}, {id: 'en', name: '英文'}],
      tagDrawer: false,
      newsDrawer: false,
      direction: "rtl",
      tagTableData: [],
      newsTableData: [],
      tagTitle: '',
      newsTitle: '',
      tagCurrentPage: 1,
      newsCurrentPage: 1,
      tagPageCount: 1,
      newsPageCount: 1,
      tagPaginate: 10,
      newsPaginate: 10,
      tagItems: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "name" }
      ],
      newsItems: [
        { name: "編號", id: "id" },
        { name: "標題", id: "title" }
      ],
      tag: null,
      news: null,
      edit: false,
      ruleForm: {
        language: 'tw',
        sort: 0,
        title: "",
        thumb: "",
        status: true,
        tag_id: 0,
        news_id: 0,
        description: '',
        id: 0
      }
    };
  },

  created() {
    if (this.$route.params.id !== undefined) {
      this.edit = true;
      this.ruleForm.id = this.$route.params.id;
      this.getData(this.$route.params.id);
    } else {
      this.ruleForm.language = this.$route.query.language;
    }
  },

  watch: {
    tagTitle: {
      async handler() {
        this.tagCurrentPage = 1;
        this.getTagsData();
      },
      immediate: true,
    },
    newsTitle: {
      async handler() {
        this.newsCurrentPage = 1;
        this.getNewsData();
      },
      immediate: true,
    }
  },

  methods: {
    getData(id) {
      var self = this;
      this.$http.get("/admin/HomeSecondary/detail", { id: id }).then(res => {
        self.ruleForm = res.data;
        self.$refs.upload.setImage({
          url: self.ruleForm.thumb,
          name: "news.jpg"
        });
        self.ruleForm.status = self.ruleForm.status==1?true:false;
        self.tag = res.data.tag;
        self.news = res.data.news;
        if(self.tag) {
          self.ruleForm.tag_id = self.tag.id;
        }
        if(self.news) {
          self.ruleForm.news_id = self.news.id;
        }
      });
    },
    onSuccess(image) {
      this.ruleForm.thumb = image.path;
    },
    onSelectTag() {
      this.getTagsData();
      this.tagDrawer = true;
    },
    onSelectNews() {
      this.getNewsData();
      this.newsDrawer = true;
    },
    getTagsData() {
      let self = this;
      this.$http.get("/admin/tags/index", {page: this.tagCurrentPage, size: this.tagPaginate, language: this.ruleForm.language, title: this.tagTitle}).then(res => {
          let {data,total} = res.data;
          self.tagPageCount = total;
          self.tagTableData = data;
      });
    },
    getNewsData() {
      let self = this;
      this.$http.get("/admin/news/index", {page: this.newsCurrentPage, size: this.newsPaginate, language: this.ruleForm.language, title: this.newsTitle}).then(res => {
          let {data,total} = res.data;
          self.newsPageCount = total;
          self.newsTableData = data;
      });
    },
    onHandleTag(value) {
      this.news = null;
      this.ruleForm.news_id = null;
      this.tag = value;
      this.ruleForm.tag_id = value.id;
      this.ruleForm.title = value.name;
      this.ruleForm.description = '';
      this.ruleForm.thumb = null;
      this.tagDrawer = false;
    },
    onHandleNews(value) {
      this.tag = null;
      this.ruleForm.tag_id = null;
      this.news = value;
      this.ruleForm.news_id = value.id;
      this.ruleForm.title = value.title;
      this.ruleForm.description = value.describe;
      this.ruleForm.thumb = value.thumb;
      this.$refs.upload.setImage({
          url: this.ruleForm.thumb,
          name: "news.jpg"
      });
      this.newsDrawer = false;
    },
    onSubmit() {
      let params = Object.assign({},this.ruleForm);
      params.status = params.status ? 1 : 0;

      if (this.tag == null && this.news == null) {
        this.$message.error("請選擇標籤或者新聞");
        return;
      }
      //params.tag_id = this.tag.id;
      //params.news_id = this.news.id;

      this.$http.post("/admin/HomeSecondary/edit", params).then(res => {
        console.log("res:", res);
        this.$message.success("編輯成功");
      });
    },
    handleTagSizeChange(size) {
      this.tagPaginate = size;
      this.getTagsData();
    },
    handleNewsSizeChange(size) {
      this.newsPaginate = size;
      this.getNewsData();
    },

    handleTagCurrentChange(val) {
      this.tagCurrentPage = val;
      this.getTagsData();
    },
    handleNewsCurrentChange(val) {
      this.newsCurrentPage = val;
      this.getNewsData();
    }
  }
};
</script>

<style lang="less">
#home-edit {
  width: 800px;
  text-align: left;
}
</style>